import React, { useEffect, useCallback, useState} from 'react';
import {
    setShowFormantPresets,
    } from 'actions/index.js';
import {connect} from 'react-redux';

const SaveFormantsFlow = ({oscillator, setShowFormantPresets}) => { 
    let [editing, setEditing] = useState(false);
    let [value, setValue] = useState('');

    const completeSave = useCallback(() => {
        oscillator.saveFormantsAsPreset(value);
        setValue("");
        setEditing(false);
    }, [value, oscillator, setValue, setEditing]);

    if (editing) {
        return (
            <div className="save-formants-flow">
              <input
                onChange={e => setValue(e.target.value)}
                value={value} type="text" placeholder="Name your Multi-Filter"/>
              <div
                onClick={completeSave}
                className="confirm-formants-btn pushable">
                Complete Save
              </div>
            </div>
        );
    }
    return (
        <div className="save-formants-flow">
        <div
              onClick={() => setEditing(true)}
              className="pushable save-formants-btn">
              Save Multi-Filter Settings
        </div>
        <div
              onClick={() => setShowFormantPresets(false)}
              className="pushable save-formants-btn done-formants-btn">
              Done
        </div>
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setShowFormantPresets: x => dispatch(setShowFormantPresets(x)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveFormantsFlow);
